import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType, OnInitEffects } from '@ngrx/effects';
import { zip } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import {
  catchError,
  concatMap,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators';
import { BinariesActions } from '../actions';
import { BinariesService } from '../services';

@Injectable()
export class BinariesEffects implements OnInitEffects {
  batchCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BinariesActions.binaryBatchCreate),
      concatMap((_) =>
        zip(
          _.batch.map((_) =>
            this.binariesService
              .binaryCreate(_)
              .pipe(
                tap((_) =>
                  this.store.dispatch(
                    BinariesActions.binaryBatchItemCreateSuccess({ binary: _ })
                  )
                )
              )
          )
        )
      ),
      mergeMap((_) => [BinariesActions.binaryBatchCreateSuccess()]),
      catchError((_) => [BinariesActions.binaryBatchCreateFailure()])
    )
  );

  listLatest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BinariesActions.listLatest),
      switchMap((_) => this.binariesService.listLatest()),
      mergeMap((_) => [BinariesActions.listLatestSuccess({ binaries: _ })]),
      catchError((_) => [BinariesActions.listLatestFailure()])
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly binariesService: BinariesService,
    private readonly store: Store
  ) {}

  ngrxOnInitEffects(): Action {
    return BinariesActions.listLatest();
  }
}
